/**
 * Modèle d'autorisation : rôle × ressource × action (§11.5).
 *
 * Les permissions ne figurent JAMAIS dans le JWT : ce sont des données mutables,
 * et les y placer signifierait qu'un retrait de droits n'agit qu'à l'expiration
 * du jeton. Elles sont calculées par requête et mises en cache 60 s côté serveur.
 */
export const RESOURCES = [
    'customer',
    'item',
    'supplier',
    'transaction',
    'invoice',
    'purchase',
    'stock',
    'appointment',
    'task',
    'document',
    'report',
    'campaign',
    'settings',
    'user',
    'platform',
];
export const ACTIONS = [
    'read',
    'create',
    'update',
    'delete',
    'validate',
    'credit',
    'adjust',
    'inventory',
    'manage',
    'manage_all',
    'admin',
];
export const ROLES = ['platform_admin', 'store_admin', 'employee', 'viewer'];
const READ_ONLY = [
    'customer:read',
    'item:read',
    'supplier:read',
    'transaction:read',
    'invoice:read',
    'stock:read',
    'appointment:read',
    'task:read',
    'document:read',
    'report:read',
    'campaign:read',
];
/**
 * Droits par défaut. Un administrateur de boutique peut créer des rôles
 * personnalisés, mais uniquement dans sa propre boutique.
 */
export const ROLE_PERMISSIONS = {
    platform_admin: ['platform:admin'],
    store_admin: [
        ...READ_ONLY,
        'customer:create',
        'customer:update',
        'customer:delete',
        'item:create',
        'item:update',
        'item:delete',
        'supplier:create',
        'supplier:update',
        'supplier:delete',
        'transaction:create',
        'transaction:update',
        'transaction:delete',
        'invoice:create',
        'invoice:validate',
        'invoice:credit',
        'purchase:create',
        'purchase:update',
        'stock:adjust',
        'stock:inventory',
        'appointment:create',
        'appointment:update',
        'appointment:delete',
        'appointment:manage_all',
        'task:create',
        'task:update',
        'task:delete',
        'document:create',
        'document:delete',
        'campaign:create',
        'campaign:update',
        'campaign:delete',
        'campaign:manage',
        'settings:manage',
        'user:manage',
    ],
    employee: [
        ...READ_ONLY.filter((p) => p !== 'report:read'),
        'customer:create',
        'customer:update',
        'transaction:create',
        'invoice:create',
        'invoice:validate',
        'appointment:create',
        'appointment:update',
        'appointment:delete',
        'task:create',
        'task:update',
        'document:create',
    ],
    viewer: READ_ONLY,
};
/**
 * `platform:admin` court-circuite la vérification, mais chaque accès d'un
 * administrateur plateforme aux données d'une boutique est journalisé.
 */
export function hasPermission(granted, required) {
    return granted.includes('platform:admin') || granted.includes(required);
}
export function permissionsForRole(role) {
    return ROLE_PERMISSIONS[role];
}
export function isPermission(value) {
    const [resource, action, ...rest] = value.split(':');
    if (resource === undefined || action === undefined || rest.length > 0)
        return false;
    return (RESOURCES.includes(resource) &&
        ACTIONS.includes(action));
}
//# sourceMappingURL=permissions.js.map